module.exports = __webpack_public_path__ + "pic/27.b5e0ecb0.png";